"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SchoolSettings = void 0;
const class_validator_1 = require("class-validator");
const mappable_base_1 = require("../../mappable.base");
const shared_1 = require("../shared");
class SchoolSettings extends mappable_base_1.MappableBase {
    constructor(settings) {
        super();
        if (!settings)
            return;
        Object.assign(this, settings);
    }
    getFields() {
        return ['timezone', 'incident', 'email_guardian_invite', 'event'];
    }
    timezone;
    incident;
    event;
    email_guardian_invite;
}
exports.SchoolSettings = SchoolSettings;
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], SchoolSettings.prototype, "timezone", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, shared_1.BoolToIntStringTransform)(),
    __metadata("design:type", String)
], SchoolSettings.prototype, "incident", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, shared_1.BoolToIntStringTransform)(),
    __metadata("design:type", String)
], SchoolSettings.prototype, "event", void 0);
__decorate([
    (0, class_validator_1.IsString)({ message: 'Email guardian invite must be true or false' }),
    (0, class_validator_1.IsOptional)(),
    (0, shared_1.BoolToIntStringTransform)(),
    __metadata("design:type", String)
], SchoolSettings.prototype, "email_guardian_invite", void 0);
